// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","result":"GenerateToken__result--UW","code":"GenerateToken__code--ma","empty":"GenerateToken__empty--iG","error":"GenerateToken__error--Wc"};